import React, { useState } from 'react';
import { Col, Container, Row } from "reactstrap"
import '../assests/css/Login.css'
import { BsFillEnvelopeFill } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import '../assests/css/Login.css'
import forgotPwdApi from '../services/forgotPwd'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IdleMonitor from './userAutoLogout'; //session management

const ForgetPwd = () => {
    const history = useHistory();
    const [disButton, setDisButton] = useState(false)

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const onSubmit = data => {
        localStorage.setItem('userEmail', data.userId);
  
        setDisButton(true);
        forgotPwdApi(data).then(res => {
    
            if(res.success === "true") { 
                localStorage.setItem('forget',"yes")
                history.push({
                    pathname : '/verify-otp',
                    type : true
                });
            }
            else {
                toast.error("User Not Exist!")
                reset(register);
                setDisButton(false);
                setTimeout(function () {
                    window.location.reload();
                }, 2000)
            }
        });
    }

    return (
        <div className="maindiv">
        <Container fluid={true}>
            <Row className="align-content-center justify-content-center align-items-center parentrow">
                <Col sm="12" md={{ size: 4, offset: 4 }}>
                    <div className="text-center bg-white middleDiv">
                        <div className="innerDiv rounded">
                            <img src="LocusB.png" alt="logo" className="logo" />
                            <div className="text-center mb-1">
                                <b><p className="text-center mb-1">Please enter your email address to receive a verification code.</p></b>
                            </div>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="py-2">
                                    <div className="form-group input-group my-3">
                                        <div className="form-group input-group-prepend">
                                            <span className="form-group input-group-text icon-setting"><BsFillEnvelopeFill /></span>
                                        </div>
                                        <input className="form-control" type="email" placeholder="Enter your email address" {...register("userId", { required: true, maxLength: 50 })} />
                                        <span className="errorSpan" style={{maringBottom : "0px"}}>{errors.userId?.type === 'required' && "*Email is required"}</span>
                                    </div>
                                </div>
                                <ToastContainer />
                                <div className="btn-margin">
                                    <button type="submit" disabled={disButton} className="btnDesg my-2">
                                        {disButton ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Submit"}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </Col>
                <Col md={4} />
            </Row>
        </Container>
        <IdleMonitor/>
    </div>
    );
}

export default ForgetPwd;


